<template>
  <div>
    <Head :title="__(title)" />

    <!-- Filtres -->
    <div class="flex flex-wrap items-center gap-4 mb-6">
      <input v-model="form.date_from" type="date" class="form-input w-44" placeholder="Date début" />
      <input v-model="form.date_to" type="date" class="form-input w-44" placeholder="Date fin" />
      <select v-model="form.result" class="form-input w-48">
        <option value="">Tous les résultats</option>
        <option value="allowed">Autorisé</option>
        <option value="denied">Refusé</option>
        <option value="blocked">Bloqué</option>
        <option value="blocked_and_alerted">Bloqué + Alerte</option>
      </select>
      <button @click="reset" class="btn-white">Réinitialiser</button>
    </div>

    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <tbody>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Date / Heure</th>
            <th class="px-6 pt-6 pb-4">Numéro (masqué)</th>
            <th class="px-6 pt-6 pb-4">Action</th>
            <th class="px-6 pt-6 pb-4">Résultat</th>
            <th class="px-6 pt-6 pb-4">Institution</th>
          </tr>
          <tr v-for="log in logs.data" :key="log.id" class="hover:bg-gray-100">
            <td class="px-6 py-3 border-t text-sm text-gray-600">{{ formatDateTime(log.created_at) }}</td>
            <td class="px-6 py-3 border-t font-mono text-sm">{{ log.phone_masked }}</td>
            <td class="px-6 py-3 border-t text-sm">{{ actionLabel(log.action) }}</td>
            <td class="px-6 py-3 border-t">
              <span :class="resultBadge(log.result)">{{ resultLabel(log.result) }}</span>
            </td>
            <td class="px-6 py-3 border-t text-sm text-gray-500">{{ log.department || '—' }}</td>
          </tr>
          <tr v-if="logs.data.length === 0">
            <td class="px-6 py-4 border-t text-gray-500" colspan="5">Aucun accès enregistré.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination class="mt-6" :links="logs.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import { Head, router } from '@inertiajs/vue3'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'

export default {
  layout: Layout,
  components: { Head, Pagination },
  props: {
    title: String,
    filters: Object,
    logs: Object,
  },
  data() {
    return {
      form: {
        date_from: this.filters.date_from || '',
        date_to:   this.filters.date_to   || '',
        result:    this.filters.result    || '',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get('/dashboard/settings/phone-lists/logs', pickBy(this.form), { preserveState: true })
      }, 300),
    },
  },
  methods: {
    reset() { this.form = mapValues(this.form, () => '') },
    formatDateTime(d) {
      if (!d) return '—'
      return new Date(d).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })
    },
    actionLabel(action) {
      const map = {
        allowed: 'Autorisé', denied: 'Refusé', blocked: 'Bloqué',
        added: 'Ajouté', removed: 'Supprimé', modified: 'Modifié',
        checked_whitelist: 'Vérif. liste blanche', checked_blacklist: 'Vérif. liste noire',
      }
      return map[action] || action
    },
    resultLabel(result) {
      const map = {
        allowed: 'Autorisé', denied: 'Refusé', blocked: 'Bloqué',
        blocked_and_alerted: 'Bloqué + Alerte',
      }
      return map[result] || result
    },
    resultBadge(result) {
      const map = {
        allowed: 'badge-green', denied: 'badge-gray',
        blocked: 'badge-red', blocked_and_alerted: 'badge-red',
      }
      return map[result] || 'badge-gray'
    },
  },
}
</script>
